import cn from 'classnames'

import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { handleListingDetailClick } from '@/utils/tracking/eventsHandlers'

import { Content } from '../GalleryAndPlanimetry'

import { modalTab } from './styled.css'

export type TabContent = {
  eventLabel?: string
  icon: React.ReactNode
  key: Content
  label: string
}

type Props = {
  activeTab: Content
  className?: string
  onTabClick: (content: Content) => void
  tabs: Array<TabContent>
}

export const ModalTabs: React.FC<Props> = ({ activeTab, className, onTabClick, tabs }) => {
  return (
    <div className={cn(className, sprinkles({ alignItems: 'center', display: 'flex' }))}>
      {tabs.map((tab) => (
        <button
          key={tab.key}
          className={modalTab({ isActive: activeTab === tab.key })}
          onClick={() => {
            handleListingDetailClick(tab.eventLabel)
            onTabClick(tab.key)
          }}
        >
          <span>{tab.icon}</span>
          <span>{tab.label}</span>
        </button>
      ))}
    </div>
  )
}
